import { kpRequest, kpEndpoint, kpParams } from '@/axios'

export const DOWNLOAD_SHIPMENT_INVOICE = 'downloadShipmentInvoice'
export const UPDATE_SHIPMENT = 'updateShipment'
export const GET_SHIPMENT = 'getShipment'
export const GET_SHIPMENT_LIST = 'getShipmentList'
export const GET_SHIPMENT_LIST_ENTITY_NAMES = 'getShipmentListEntityNames'
export const CREATE_SHIPMENT = 'createShipment'
export const CREATE_PARTIAL_SHIPMENT = 'createPartialShipment'
export const EXPORT_SHIPMENT = 'exportShipment'
export const IMPORT_SHIPMENT = 'importShipment'
export const CREATE_BULK_SHIPMENT = 'createBulkShipment'
export const GET_BULK_SHIPMENT_STATUS = 'getBulkShipmentStatus'
export const RETRY_BULK_SHIPMENT = 'retryBulkShipment'
export const GET_ACTIVE_BULK_SHIPMENT = 'getActiveBulkShipment'
export const BULK_EXPORT_SHIPMENTS = 'bulkExportShipments'
export const GET_SHIPMENT_INVOICE_AVAILABILITY = 'getShipmentInvoiceAvailability'
export const RETURN_PRODUCTS_TO_ORDER = 'returnProductsToOrder'
export const GET_RETURNABLE_PRODUCTS = 'getReturnableProducts'
export const BULK_RETURN_PRODUCTS_TO_ORDER = 'bulkReturnProductsToOrder'

const actions = {
  async [DOWNLOAD_SHIPMENT_INVOICE](ctx, shipmentId) {
    const response = await kpRequest({
        ...kpParams(kpEndpoint.shipment.downloadInvoice, shipmentId),
        responseType: 'blob',
        headers: {
            Accept: 'application/pdf, application/json',
        },
    })
    const contentType = response.headers['content-type']
    if (contentType.includes('application/pdf')) {
        return response
    } else if (contentType.includes('application/json')) {
        return JSON.parse(await response.data.text())
    } else {
        throw new Error('Unsupported content type')
    }
  },
  async [UPDATE_SHIPMENT](ctx, { shipmentId, payload }) {
    return await kpRequest({ ...kpParams(kpEndpoint.shipment.update, shipmentId), payload })
  },
  async [GET_SHIPMENT](ctx, shipmentId) {
    return await kpRequest({ ...kpParams(kpEndpoint.shipment.getById, shipmentId) })
  },
  async [GET_SHIPMENT_LIST](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.shipment.get, params })
  },
  async [GET_SHIPMENT_LIST_ENTITY_NAMES](ctx, { role, params = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.shipment.filterByEntityName, role), params })
  },

  async [CREATE_SHIPMENT](ctx, payload = {}) {
    return await kpRequest({ ...kpEndpoint.shipment.create, payload })
  },

  async [CREATE_PARTIAL_SHIPMENT](ctx, payload = {}) {
    return await kpRequest({ ...kpEndpoint.shipment.createPartial, payload })
  },

  async [EXPORT_SHIPMENT](ctx, payload = {}) {
    return await kpRequest({
      ...kpEndpoint.shipment.export,
      payload,
      responseType: 'blob',
    })
  },

  async [IMPORT_SHIPMENT](ctx, payload = {}) {
    return await kpRequest({ ...kpEndpoint.shipment.import, payload })
  },

  async [CREATE_BULK_SHIPMENT](ctx, payload = {}) {
    return await kpRequest({ ...kpEndpoint.shipment.bulkCreate, payload })
  },

  async [GET_BULK_SHIPMENT_STATUS](ctx, batchId) {
    return await kpRequest({ ...kpParams(kpEndpoint.shipment.bulkStatus, batchId) })
  },

  async [RETRY_BULK_SHIPMENT](ctx, { batchId, payload = {} }) {
    return await kpRequest({ ...kpParams(kpEndpoint.shipment.bulkRetry, batchId), payload })
  },

  async [GET_ACTIVE_BULK_SHIPMENT]() {
    return await kpRequest({ ...kpEndpoint.shipment.bulkActive })
  },

  async [BULK_EXPORT_SHIPMENTS](ctx, payload = {}) {
    return await kpRequest({ ...kpEndpoint.downloads.shipmentBulkExport, payload })
  },

  async [GET_SHIPMENT_INVOICE_AVAILABILITY](ctx, payload = {}) {
    return await kpRequest({ ...kpEndpoint.shipment.invoiceAvailability, payload })
  },

  async [RETURN_PRODUCTS_TO_ORDER](ctx, { shipmentId, productIds }) {
    return await kpRequest({
      ...kpParams(kpEndpoint.shipment.returnProductsToOrder, shipmentId),
      payload: { productIds },
    })
  },

  async [GET_RETURNABLE_PRODUCTS](ctx, params = {}) {
    return await kpRequest({ ...kpEndpoint.shipment.returnableProducts, params })
  },

  async [BULK_RETURN_PRODUCTS_TO_ORDER](ctx, { shipmentIds, productIds }) {
    return await kpRequest({
      ...kpEndpoint.shipment.bulkReturnProductsToOrder,
      payload: { shipmentIds, productIds },
    })
  },
}

export default {
  actions,
}
